import styles from './SectionLabel.module.css'

interface SectionLabelProps {
  children: string
  className?: string
}

export function SectionLabel({ children, className = '' }: SectionLabelProps) {
  return <p className={`${styles.label} ${className}`.trim()}>{children}</p>
}
